import { CoachViewableSessionFeedbackPage } from '@/components/feedbacks/coach-viewable-session-feedback-page';
import { InfoPageSuspenseBoundary } from '@/components/info-page-suspense-boundary';
import { airServerErrorFrom, axiosErrorFrom } from '@/lib/error-handling';
import { validateRouteRole } from '@/lib/routing';
import { parseSessionFeedbackCompoundId } from '@/lib/string-utils';
import { isCoach } from '@airreading/common';
import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/teachers-feedback/$feedbackId')({
  beforeLoad: validateRouteRole(isCoach),
  component: Page,

  loader: ({ params }) => {
    const feedbackCompoundId = parseSessionFeedbackCompoundId(params.feedbackId);
    if (!feedbackCompoundId.sessionId || !feedbackCompoundId.studentId || !feedbackCompoundId.coachId) {
      throw notFound();
    }

    return {
      feedbackCompoundId,
    };
  },
});

function Page() {
  return (
    <InfoPageSuspenseBoundary
      onError={(e) => {
        const axiosError = axiosErrorFrom(e);
        const airServerError = airServerErrorFrom(e);

        return {
          allowRetry: axiosError?.response?.status !== 404,
          errorHeader: airServerError?.userFacingMessage || 'Failed to load class feedback. Please try again.',
          back: {
            backLink: {
              to: '/my-classes/past',
            },
          },
        };
      }}
    >
      <FeedbackDetails />
    </InfoPageSuspenseBoundary>
  );
}

function FeedbackDetails() {
  const { feedbackCompoundId } = Route.useLoaderData();
  return <CoachViewableSessionFeedbackPage feedbackCompoundId={feedbackCompoundId} />;
}
